<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div id="templatePane">
    <div class="hero-section" style="background-image:url(/static/images/hero-broken.png)">
      <div class="hero-section-text row column">
        <h1>Oops, looks like we need to fix something</h1>
      </div>
    </div>
    <section id="mainContent" class="row column">
      <h2>Sorry, but we couldn't set your preferences</h2>
      <p>We've hit a glitch when trying to set your preferences.  But don't worry, you don't have to do anything as we have let our support teams know what's happened so they can investigate.</p>
      <p>Of course, feel free to try again in a few hours time or tomorrow in case it was a blip, but if it still doesn't work, give us a couple of days to investigate.</p>

      <p>If you've access to the BT intranet, head to FixIT where we have <a href="https://fixit.bt.com/pages/browsebysubject.aspx?contentcenter=Workplace%20by%20Facebook">lots of articles</a> that may be able to help.</p>
      <!--section v-if="bearerToken">
        <p><a href="/phone-number">Go back to phone-number</a></p>
      </section>
      <section v-else>
        <p><a href="/">Return to the home page</a></p>
      </section-->

    </section>
  </div>
</template>

<script>
var ES6Promise = require("es6-promise")
ES6Promise.polyfill()
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import {fixitContentCentre} from '../commonError'

export default {
  name: 'ErrorMfaNotSet',
  title: "Workplace - We couldn't set your preferences",
  data: function() {
    return {
      bearerToken: "",
      fixitContentCentre: fixitContentCentre
    }
  },
  mounted() {
    this.bearerToken = this.$cookie.get('token');
  }
}

</script>
